export default {"src":"/_next/static/media/img-bfy-mobile-4.7765f40b.svg","height":301,"width":326,"blurWidth":0,"blurHeight":0};